export const NavBarOptions = [
  {
    key: 1,
    title: "Autorizaciones",
    type: "secundario",
    redirectTo: "/autorizacion",
    hasSubmenu: true,
    submenu: [
      {
        subtitle: "Solicitar Autorización",
        redirectTo: "/autorizacion",
      },
      {
        subtitle: "Búsqueda Avanzada",
        redirectTo: "/busqueda-autorizacion",
      },
    ],
  },
  {
    key: 2,
    title: "Precertificaciones",
    type: "principal",
    redirectTo: "/confirmar-precertificacion",
    hasSubmenu: true,
    submenu: [
      {
        subtitle: "Confirmar",
        redirectTo: "/confirmar-precertificacion",
      },
      {
        subtitle: "Cancelar",
        redirectTo: "/cancelar-precertificacion",
      },
    ],
  },
  {
    key: 3,
    title: "Stand Virtual",
    type: "principal",
    redirectTo: process.env.REACT_APP_STAND_VIRTUAL_URL,
    hasSubmenu: false,
    isStandVirtual: true,
  },
  {
    key: 4,
    title: "Promoción y Prevención",
    type: "principal",
    redirectTo: "/autorizacion",
    hasSubmenu: false,
    isPyp: true,
  },
];
